var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-card",
    { attrs: { "no-body": "" } },
    [
      _c(
        "b-card-header",
        [
          _c(
            "b-form",
            { attrs: { inline: "" } },
            [
              _c("worker-select", {
                ref: "worker_select",
                staticClass: "ml-2 mr-2 flex-fill",
                attrs: { id: "worker-select", "is-disabled": _vm.isDisabled },
                on: { onSelect: _vm.onSelect }
              }),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: {
                    variant: "success",
                    size: "sm",
                    disabled: _vm.isDisabled || !_vm.selectedWorkerId
                  },
                  on: {
                    click: function($event) {
                      return _vm.onAdd(_vm.selectedWorkerId)
                    }
                  }
                },
                [
                  _c("font-awesome-icon", {
                    staticClass: "mr-1",
                    attrs: { icon: "plus" }
                  }),
                  _vm._v("\n          Добавить\n        ")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("b-table", {
        ref: "location-workers",
        staticClass: "mb-0",
        attrs: {
          id: "location-workers",
          striped: "",
          small: "",
          "thead-class": "top-fixed-thead thead-light",
          "table-class": "text-small",
          responsive: "",
          "show-empty": "",
          busy: _vm.isBusy,
          items: _vm.items,
          fields: _vm.fields,
          "current-page": _vm.currentPage,
          "per-page": _vm.perPage,
          "empty-text": _vm.$t("message.common.emptyTable")
        },
        on: {
          "update:busy": function($event) {
            _vm.isBusy = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "table-busy",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "text-center text-success my-2" },
                  [
                    _c("b-spinner", { staticClass: "align-middle" }),
                    _vm._v(" "),
                    _c("strong", [_vm._v("Загрузка")])
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "cell(name)",
            fn: function(row) {
              return [_vm._v("\n        " + _vm._s(row.item.name) + "\n      ")]
            }
          },
          {
            key: "cell(action)",
            fn: function(row) {
              return [
                _c(
                  "b-button",
                  {
                    attrs: {
                      variant: "danger",
                      size: "sm",
                      disabled: _vm.isDisabled
                    },
                    on: {
                      click: function($event) {
                        return _vm.onRemove(row.item)
                      }
                    }
                  },
                  [_c("font-awesome-icon", { attrs: { icon: "trash" } })],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-125d96ef", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-125d96ef","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Locations/LocationWorkers.vue
// module id = null
// module chunks = 